$(document).ready(function(){

    /* Smooth anchor scroll landing */

    $('a.anchor:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top -25
                }, 1000);
                return false;
            }
        }
    });

    /**************
* Smooth anchor scroll
*/ 

    /*$('a.anchor:not([href="#"])').on('click', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();

    // Fa ricalcolare a slick l'altezza, altrimenti lo slider presente nella tab nascosta risulta alto 0 e quindi non si vede
    //$('.slider-gallery').slick('setPosition');

    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {

            // se scrolli con il mouse si interrompe lo smooth scroll
            $('html, body').bind('mousewheel', function(e){ 
                $(this).stop();
            });

            $('html, body').animate({
                scrollTop: target.offset().top -130
            }, 600);

            return false;
        }
    }
});*/

    /*Menu mobile 
     * Apertura sottomenu solo sotto i 768px */

    if (window.matchMedia("(max-width: 767px)").matches) {
        $('.submenu').removeClass('is-visible');

        $('.mobile-only [data-submenu]').on('click', function(e){
            e.preventDefault();           
            var className = $(this).attr("data-submenu");
            $('.'+className+'.submenu').addClass('is-visible');
            //console.log(className);
            $('body').addClass('submenu-expanded');
        });


        $('.mobile-only .close-submenu').on('click',function(e){
            e.preventDefault();
            $('body').removeClass('submenu-expanded');
            $(this).parent().removeClass('is-visible');
        });


        $('.mobile-only .close').on('click',function(e){
            e.preventDefault();
            $('body').removeClass();
            $('.'+className+'.submenu').removeClass('is-visible');
        });

    }



    /* Menu mobile 
     * Apre e chiude menu dispositivi mobile, attivato tramite media queries in header.scss */
    $('.nav-toggle').on('click',function(e){
        e.preventDefault();
        $('body').toggleClass('nav-expanded');
    });

    /* Google map
     * Disable scroll wheel on iframe google map */

    $('.map').click(function () {
        $('.map iframe').css("pointer-events", "auto");
    });

    $( ".map" ).mouseleave(function() {
        $('.map iframe').css("pointer-events", "none"); 
    });

    $('.slider').slick();

    /*$('.slider-gallery').slick({
        asNavFor: '.slider-gallery-nav'
    });*/




    $('.slider-gallery-nav').slick({
        slidesToShow: 20,
        slidesToScroll: 20,
        //asNavFor: '.slider-gallery',
        dots: false,
        focusOnSelect: true,
        infinite:true,
        centerMode: true,
        centerPadding: 10,
        loopAtEnd: true,
        variableWidth:true, //importante per avere un margine diverso

        responsive: [  
            {
                breakpoint: 1200,
                settings: {
                    centerMode: true,
                    slidesToShow: 20,
                    slidesToScroll: 20
                }
            },
            {
                breakpoint: 896,
                settings: {
                    centerMode: true,
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: 640,
                settings: {
                    centerMode: true,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 470,
                settings: {
                    centerMode: true,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]        

    });




    $('.slider-gallery-nav').slickLightbox({
        src: 'src',
        itemSelector: 'div img',
        navigateByKeyboard : true,
        caption: 'caption'
    });


   /* $('.slider-realizzazioni').slick({
        centerMode: true,
        centerPadding: '26.6vw',
        slidesToShow: 1,
        dots: true,
        arrows:false 
    });*/


    $('.masthead__img').slick({
        dots: false,
        arrows: false,
        infinite: true,
        //autoplay: false,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1250,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        //initialSlide: 0,
    });


    $('.slider-fascia').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        responsive: [
             {
                breakpoint: 1200, //fino a
                settings: {
                dots: false
                }
            }
            
        ]       
    });

    $('.slider-fascia').slickLightbox({
        //src: 'data-src-full',
        //src: 'src',
        //itemSelector: 'div img',
        navigateByKeyboard : true,
        caption: 'caption',
        destroyTimeout: 100
    })


    // Per evitare che al clic sulla X si apra il menu sottostante
    /*$(".swipebox").swipebox({
        afterOpen: function(){
            var $selectorClose = $("#swipebox-close");
            var clickAction = "touchend click";

            $selectorClose.unbind(clickAction);

            $selectorClose.bind(clickAction, function(event){
                event.preventDefault();
                event.stopPropagation();

                $.swipebox.close();
            });
        }
    });*/

    /* Ricerca */

    // Click sull'icona lente
    $('.search button').click(function(e){
        e.preventDefault();
        openSearchModal($(this).parent().find('[name="s"]').val());
    });

    // Invio sul campo di ricerca in header
    /*
    $('.search form').submit(function(e){
        e.preventDefault();
        openSearchModal($(this).find('[name="s"]').val());
    });
    */

    // Update: evitiamo di dare la possibilita' di scrivere nella barra di ricerca ma al clic apriamo la modale
    $('.search input').click(function(e){
        e.preventDefault();
        openSearchModal('');
    });

    // Apro la ricerca popup (AJAX) con testo precompilato dal campo in header
    function openSearchModal(text) {
        $(".search-block [name='s']").val(text).trigger("keyup"); 
        $(".search-block").addClass('is-visible');
    }

    // Chiudo la ricerca popup
    $('.search-block .btn-close').click(function(e){
        e.preventDefault();
        $(".search-block").removeClass('is-visible');
    });


    // FALLBACK OBJECT-FIT IE
    if(!Modernizr.objectfit) {
        $('.slider-gallery img, #swipebox-slider img').each(function(){
            //console.log("Sono in FALLBACK OBJECT-FIT IE");
            var imgSrc = $(this).attr('src');
            if (! imgSrc) imgSrc = $(this).attr('data-lazy');

            var fitType = 'cover';

            if($(this).data('fit-type')) {
                fitType = $(this).data('fit-type');
            }

            $(this).parent().css({ 'background' : 'transparent url("'+imgSrc+'") no-repeat center center/'+fitType, });
            $(this).remove(); });
    }


});

// js per le landing - START
$(document).ready(function() {
    //Menu
    $('.js-toggleMenu').on('click', function(e) {
        e.preventDefault();

        $(this).toggleClass('is-open');
        $('body').toggleClass('nav-expanded');
    });

    if (window.matchMedia("(max-width: 991px)").matches) {
        $('nav ul a').on('click', function(event) {
            $('body').toggleClass('nav-expanded');
            $('.js-toggleMenu').toggleClass('is-open');
        });
    }

    /* Smooth anchor scroll landing */

    $('a.anchorLanding:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location
            .hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 75
                }, 1000);
                return false;
            }
        }
    });

    //Slider full width
    $('.slider-landing').slick({
        arrows: true,
        dots: true,
        infinite: true,
        slidesToShow: 1, 
        autoplay: true,
        //autoplaySpeed: 2000,
        autoplaySpeed: 6000,
        //speed: 300,
        speed: 600,
    });

    $('.slider-products').slick({
        arrows: true,
        speed: 300,
        slidesToShow: 3,
        responsive: [{
                breakpoint: 768,
                settings: {
                    //arrows: false,
                    centerMode: true,
                    //centerPadding: '40px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });

    //Accordion
    $('.accordion .accordion__item.accordion__content').show();

    var accordionItem = document.querySelectorAll('.accordion__item');
    for (var i = 0; i < accordionItem.length; i++) {
        accordionItem[i].classList.add('js-item');
    }

    var title = document.querySelectorAll('.accordion__header');
    for (var i = 0; i < title.length; i++) {
        title[i].classList.add('js-header');
    }

    var copy = document.querySelectorAll('.accordion__content');
    for (var i = 0; i < copy.length; i++) {
        copy[i].classList.add('js-content');
    }

    $('.accordion .js-content').slideUp();
    $('.accordion__item .js-header').attr('aria-expanded', 'false');

    // Primo elemento aperto
    //$('.accordion .accordion__item:first-child .js-header').toggleClass('active');
    //$('.accordion .accordion__item:first-child .js-content').slideDown();
    //$('.accordion__item:first-child .js-header').attr('aria-expanded','true');


    //var $title = $('.accordion .js-header');

    $('.accordion .js-header').click(function() {
        console.log('ccc');
        $(this).next(copy).slideToggle();
        $(this).toggleClass('active');


        // toggle attributi
        if ($(this).attr('aria-expanded') == 'true') {
            $(this).attr('aria-expanded', 'false');
        } else if ($(this).attr('aria-expanded') == 'false') {
            $(this).attr('aria-expanded', 'true').siblings().attr('aria-expanded', 'false');
        }

        return false;

    });

    var $accordionItem = $(
        '.accordion .js-item'
    ); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header

    $accordionItem.keydown(function(e) { // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina

        var keyCode = e.keyCode || e.which;
        if (keyCode == 13 || keyCode == 32) { // all'invio o alla space-bar
            $(this).children(title).next(copy).slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');

            $(this).siblings().children().removeClass('active');


            if ($(this).children(title).attr('aria-expanded') == 'true') {
                $(this).children(title).attr('aria-expanded', 'false');
            } else if ($(this).children(title).attr('aria-expanded') == 'false') {
                $(this).children(title).attr('aria-expanded', 'true').siblings().attr('aria-expanded',
                    'false');
            }

            return false;
        }

    });
})
// js per le landing - END
